import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  modalBody: {
    "& .mantine-1q36a81:not(:only-child)": {
      background: "#F5F5F5",
    },
  },
  modalHeader: {
    padding: "13px 19px",
    "& .mantine-Modal-title": {
      flex: 1,
      textAlign: "center",
    },
  },
  contentBoxParent: {
    padding: "16px 24px",
  },
  contentBox: {
    padding: "30px 16px 24px 16px",
    borderRadius: "6px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
    minHeight: 397,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 20,
    "& .infoText": {
      color: "#0F172A",
      fontFamily: "Inter",
      fontSize: 14,
      textAlign: "center",
      width: "85%",
      fontWeight: 400,
    },
  },
  modalTitle: {
    display: "flex",
    justifyContent: "center",
    gap: 10,
    alignItems: "center",
    fontSize: 24,
    fontFamily: "Inter",
    color: "#000",
    fontWeight: 700,
    "& svg": {
      color: "#F04438",
    },
  },
  qrBox: {
    padding: 16,
    borderRadius: 8,
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },
  secretKeyBox: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 12px",
    borderRadius: 8,
    border: "1px solid #CBD5E1",
    background: "#F8FAFC",
    fontFamily: "monospace",
    fontSize: 14,
    letterSpacing: 1,
    color: "#0F172A",
    wordBreak: "break-all",
  },
  pinInput: {
    fontFamily: "Inter",
  },
  login_btn: {
    "@media (max-width :48em)": {
      width: "100%",
    },
    "@media (max-width :800px)": {
      width: "100%",
    },
    background: "#000 ",
    width: "100%",
    height: rem(50),
    fontFamily: "Inter",
    fontSize: "22px",
    marginTop: 20,
    borderRadius: "4px",
    color: "#FFF",
    textAlign: "center",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    ":hover": {
      background: "#000",
      opacity: 0.8,
    },
  },
  customokbutton: {
    background: "var(--app-primary)  !important",
    color: "var(--app-on-primary) !important",
    width: "440px !important",
    height: "44px !important",
    border: "1px solid var(--app-primary); !important",
    borderRadius: "8px !important",
    boxShadow: " 0 1px 2px 0 rgba(16, 24, 40, 0.05) !important",
    padding: "8px 14px !important",
  },
}));

export default useStyles;
